import { useMemo } from "react";
import { OrderedMap } from "immutable";
import useLayoutVariant from "components/common/PaginatedEntityTable/hooks/useLayoutVariant";
import { serializeTimeRange } from "components/common/EntityFilters/helpers/timeRange";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
import { defaultTimeRange } from "components/events/fetchEvents";
const nonInfoPriorities = Object.keys(EventDefinitionPriorityEnum.properties).reverse().filter((key) => key !== String(EventDefinitionPriorityEnum.INFO));
const baseDefaultFilters = OrderedMap({
  priority: nonInfoPriorities,
  timestamp: [serializeTimeRange(defaultTimeRange)]
});
const useAlertsEntityTableDefaultFilters = (entityTableId) => {
  const { activeLayoutVariant } = useLayoutVariant();
  const {
    data: { defaultFilters }
  } = useUserLayoutPreferences(entityTableId, activeLayoutVariant);
  return useMemo(() => {
    if (defaultFilters) return baseDefaultFilters.merge(defaultFilters);
    return baseDefaultFilters;
  }, [defaultFilters]);
};
export default useAlertsEntityTableDefaultFilters;
